import React from 'react';
import styled from 'styled-components';


/**
 * Color:
 * 
 * d1caf4 - lavender
 */

const Wrapper = styled.div`
  padding: 25px;
  text-align: left;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background: #fff;
  margin-bottom: 30px;
`;

const Title = styled.div`
  font-family: 'Rouge Script', cursive;
  font-size: 2.5em;
  margin-bottom: 30px;
`;

const CardFooter = styled.div`
  text-align: center;
  color: #D80000;
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 2em;
  margin-top: 40px;
  margin-bottom: 30px;
`;

export const Anchor = styled.div`
  display: block;
  position: relative;
  top: -100px;
  visibility: hidden;
`;


const Section = (props) => {
  return (
    <Wrapper>
      <Anchor id={props.id} />
      <Title>{props.title}</Title>
      <div>
        {props.children}
      </div>
      <CardFooter>
        囍
      </CardFooter>
    </Wrapper>
  );
}

export default Section;